// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"XCloseButton_ProseMirror__3YyZx","xCloseButton":"XCloseButton_xCloseButton__xBlky","xCloseButton__icon":"XCloseButton_xCloseButton__icon__2UPJW"};